import React, { useState } from 'react';
import { Avatar } from '../../../../utils/avatar'; // Ajusta la ruta a tu componente Avatar
import { Badge } from '../componentes/UserCard'; // Reutilizamos el Badge que ya tienes
import { User, BarChart2, History } from 'lucide-react'; // Iconos para las pestañas
import { formatearFechaCompleta } from '../../../../utils/utils';

// --- Sub-componentes para mantener el código limpio ---

// 1. Un botón para las pestañas de navegación
const TabButton = ({ tabId, activeTab, setActiveTab, icon, label }) => {
    const isActive = activeTab === tabId;
    return (
        <button
            onClick={() => setActiveTab(tabId)}
            className={`flex flex-col items-center justify-center p-2 w-full transition-colors duration-200 ${
                isActive ? 'text-sky-600 border-b-2 border-sky-600' : 'text-gray-500 hover:bg-gray-100'
            }`}
        >
            {icon}
            <span className="text-xs font-semibold mt-1">{label}</span>
        </button>
    );
};

// 2. Una fila para mostrar detalles (Label + Value)
const DetailRow = ({ label, value, isEditable = false }) => (
    <div className="mb-3">
        <p className="text-xs text-gray-500 font-semibold uppercase tracking-wider">{label}</p>
        {isEditable ? (
             <textarea
                className="w-full mt-1 p-2 border border-gray-300 rounded-md text-sm bg-white"
                rows="4"
                defaultValue={value || ''}
                placeholder={`Añadir ${label.toLowerCase()}...`}
            />
        ) : (
            <p className="text-sm text-gray-900 break-words">{value || '-'}</p>
        )}
    </div>
);


// --- Componente Principal: ClientContextPanel ---

const ClienteContexto = ({ chat }) => {
    const [activeTab, setActiveTab] = useState('detalles'); // El estado para la pestaña activa

    if (!chat) {
        return (
            <div className="w-96 h-full border-l border-gray-200 bg-white flex items-center justify-center p-4">
                <p className="text-gray-500 text-center">Selecciona un chat para ver los detalles del cliente.</p>
            </div>
        );
    }

    // Usamos optional chaining (?.) para evitar errores si clienteInfo no existe
    const cliente = chat?.clienteInfo;
    const displayName = cliente?.nombrecompletoCliente !== "PROSPECTO CLIENTE" ? cliente.nombreCliente : chat.name;

    return (
        <div className="w-96 h-full border-l border-gray-200 bg-gray-50 flex-shrink-0 flex flex-col">
            {/* Cabecera del Panel */}
            <div className="p-4 text-center bg-white border-b border-gray-200">
                <div className="flex justify-center mb-2">
                    <Avatar name={displayName} size="lg" />
                </div>
                <h2 className="text-xl font-bold text-gray-800">{displayName}</h2>
                <p className="text-sm text-gray-500">{chat.phone_number}</p>
            </div>

            {/* Barra de Pestañas / Navegación */}
            <div className="flex bg-white border-b border-gray-200">
                <TabButton tabId="detalles" activeTab={activeTab} setActiveTab={setActiveTab} icon={<User size={20} />} label="Detalles" />
                <TabButton tabId="estadisticas" activeTab={activeTab} setActiveTab={setActiveTab} icon={<BarChart2 size={20} />} label="Estadísticas" />
                <TabButton tabId="historial" activeTab={activeTab} setActiveTab={setActiveTab} icon={<History size={20} />} label="Historial" />
            </div>

            {/* Contenido dinámico según la pestaña seleccionada */}
            <div className="flex-grow p-4 overflow-y-auto">
                {activeTab === 'detalles' && (
                    <div>
                        <h3 className="font-bold text-gray-800 mb-4 text-md">Información de Contacto</h3>
                        <DetailRow label="Nombre Completo" value={cliente?.nombrecompletoCliente} />
                        <DetailRow label="Teléfono" value={chat.phone_number} />
                        <DetailRow label="Email" value={cliente?.email} />
                        <DetailRow label="Carrera" value={cliente?.carrera} />
                        <DetailRow label="Universidad" value={cliente?.universidad} />
                        {formatearFechaCompleta(chat.clienteInfo.AtribucionAnuncio)}
                        
                        <hr className="my-4" />

                        <h3 className="font-bold text-gray-800 mb-4 text-md">Etiqueta Actual</h3>
                        <div className="mb-4">
                            {chat.label && <Badge text={chat.label} />}
                        </div>

                        <hr className="my-4" />

                        <DetailRow label="Notas" value={cliente?.notas} isEditable={true} />
                    </div>
                )}
                
                {activeTab === 'estadisticas' && (
                    <div className="text-center text-gray-500 pt-10">
                        <BarChart2 size={40} className="mx-auto mb-2" />
                        <p>Las estadísticas del cliente estarán disponibles aquí próximamente.</p>
                    </div>
                )}

                {activeTab === 'historial' && (
                     <div className="text-center text-gray-500 pt-10">
                        <History size={40} className="mx-auto mb-2" />
                        <p>El historial de solicitudes del cliente aparecerá en esta sección.</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ClienteContexto;